import React from 'react';
import { View } from '@shared/components/View';
import { MBBlockLabel } from '@shared/components/blocks/utils/label';
import { i18n } from '@shared/util/i18n';

export function CompressedTodoBlock({ block, todos }) {
  return (
    <View paddingHorizontal={3} paddingTop={1}>
      <MBBlockLabel
        label={
          !todos?.length
            ? block.label
            : i18n('card.blocks.todoInput.label', {
                label: block.label,
                totalCount: todos.length,
                completedCount: todos.filter(item => item.status === 'COMPLETED').length,
              })
        }
      />
    </View>
  );
}
